import React from "react";
import "./PlatformTable.css";

const PlatformTable = ({ data }) => (
  <table className="platform-table">
    <thead>
      <tr>
        <th>Platform</th>
        <th>Posts</th>
        <th>Views</th>
        <th>Clicks</th>
      </tr>
    </thead>
    <tbody>
      {data.map((row) => (
        <tr key={row.platform}>
          <td>{row.platform}</td>
          <td>{row.posts}</td>
          <td>{row.views}</td>
          <td>{row.clicks}</td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default PlatformTable;
